import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeviationResourceType, getTranslatedDeviationTitle, } from '../../../DeviationViews/_helpers';
import { DeviationDuperbrowseContext, DeviationLink, } from '../../../Duperbrowse';
import DeviationDumbViewWithIcon from '../../../DeviationViews/DumboWithIcon';
import SidebarGrid from '../SidebarGrid';
var DeviationSidebarGrid = function (_a) {
    var streamId = _a.streamId, deviations = _a.deviations, parentDeviation = _a.parentDeviation, maxRows = _a.maxRows, className = _a.className;
    var t = useTranslation().t;
    var renderDeviation = useCallback(function (_a) {
        var item = _a.item, width = _a.width, height = _a.height, itemClassName = _a.className;
        return (React.createElement(DeviationLink, { deviation: item, key: item.deviationId, className: itemClassName, title: getTranslatedDeviationTitle(item, t) },
            React.createElement(DeviationDumbViewWithIcon, { deviation: item, width: width, height: height, greenLikeCrop: true })));
    }, [t]);
    return (React.createElement(DeviationDuperbrowseContext, { streamId: streamId, deviations: deviations, parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId,
        } },
        React.createElement(SidebarGrid, { items: deviations, maxRows: maxRows, className: className, renderItem: renderDeviation })));
};
DeviationSidebarGrid.displayName = 'DeviationSidebarGrid';
export default DeviationSidebarGrid;
//# sourceMappingURL=DeviationSidebarGrid.js.map